import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../locals/constants";
import React from "react";

export const PrivacyPolicyLink = ()=>{
	const { t } = useTranslation(NAME_SPACES.ACCOUNT);

	return (<a target={"private-policy-doc"} href={"/privacy-policy"}>{t("CONTACT.PRIVACY_POLICY_LINK_LABEL")}</a>);
}
